import { render, staticRenderFns } from "./PayForm.vue?vue&type=template&id=a52b77c2&scoped=true&"
import script from "./PayForm.vue?vue&type=script&lang=js&"
export * from "./PayForm.vue?vue&type=script&lang=js&"
import style0 from "./PayForm.vue?vue&type=style&index=0&id=a52b77c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52b77c2",
  null
  
)

export default component.exports